import { Controller } from '@hotwired/stimulus'

export default class DashboardOngoingSwitchController extends Controller {
  static targets = ['ongoing', 'lifetime'];

  select(event) {
    const mode = event.target.value;

    if (mode === 'lifetime') {
      this.ongoingTarget.hidden = true;
      this.lifetimeTarget.hidden = false;
    } else {
      this.ongoingTarget.hidden = false;
      this.lifetimeTarget.hidden = true;
    }
  }
}
